module.exports = __webpack_public_path__ + "img/awards_image_26.362a5be2.jpg";